<div class="flex flex-col items-stretch justify-center h-28">
    <a [routerLink]="routerLink"
        class="flex flex-row items-center gap-2.5 leading-11 px-10 text-zen-lite text-xs btn rounded-sm h-11 hover:bg-opacity-5 hover:bg-zen uppercase">
        <div class="flex flex-row items-center gap-2.5" #content [hidden]="!content.hasChildNodes()">
            <ng-content></ng-content>
        </div>
        <span *ngIf="!content.hasChildNodes()">Click me</span>
    </a>
</div>